<template>
  <div class="client-setup-container">
    <template v-if="clientSetupData && clientSetupData.macAddr">
      <div class="setup-item">
        <span class="item-name client-uuid">客户端ID</span>
        <a-input class="uuid-code" :value="clientSetupData.macAddr || '暂无'" disabled></a-input>
        <a-button type="primary" ghost @click="confirmOrCancelUnbindClient(clientSetupData.macAddr)">解绑</a-button>
      </div>
      <div class="option-item" v-if="clientSetupData && clientSetupData.macAddr">
        <div class="option-title">远程控制</div>
        <div class="choose-box">
          <a-button type="primary" ghost :disabled="showRestartBtn ? false : true" @click="handleRestart">
            重启客户端
          </a-button>
        </div>
      </div>
      <div class="option-item" v-if="clientSetupData && clientSetupData.macAddr">
        <div class="option-title">启动时</div>
        <div class="choose-box">
          <a-checkbox
            :defaultChecked="clientSetupData.openShareScreen ? true : false"
            @change="handleUpdateSetting({ openShareScreen: $event.target.checked ? 1 : 0 })"
          >
            自动开启“屏幕共享”
          </a-checkbox>
          <a-checkbox
            :defaultChecked="clientSetupData.autoStart ? true : false"
            @change="handleUpdateSetting({ autoStart: $event.target.checked ? 1 : 0 })"
          >
            开机时启动客户端
          </a-checkbox>
          <a-checkbox
            :defaultChecked="clientSetupData.autoLogin ? true : false"
            @change="handleUpdateSetting({ autoLogin: $event.target.checked ? 1 : 0 })"
          >
            自动登录
          </a-checkbox>
          <a-checkbox
            :defaultChecked="clientSetupData.autoCreateLive ? true : false"
            @change="handleUpdateSetting({ autoCreateLive: $event.target.checked ? 1 : 0 })"
          >
            自动开课
          </a-checkbox>
          <div class="select-option">
            <span class="select-title">开课默认状态</span>
            <a-select
              :value="clientSetupData.windowType"
              class="m-2 type-select"
              placeholder="选择开课默认状态"
              style="width: 200px"
              @change="handleWindowType"
            >
              <a-select-option v-for="item in windowList" :key="item.value" :value="item.value">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </div>
          <div class="select-option">
            <span class="select-title">小窗默认位置</span>
            <a-select
              :value="clientSetupData.miniWindowPositionType"
              class="m-2 type-select"
              placeholder="选择小窗默认位置"
              style="width: 200px"
              @change="handleWindowPos"
            >
              <a-select-option v-for="item in posList" :key="item.value" :value="item.value">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </div>
        </div>
      </div>
      <div class="option-item advance-set" v-if="clientSetupData && clientSetupData.macAddr">
        <div class="option-title">高级设置</div>
        <div class="choose-box">
          <a-checkbox
            :defaultChecked="clientSetupData.enabledDebugMode ? true : false"
            @change="handleUpdateSetting({ enabledDebugMode: $event.target.checked ? 1 : 0 })"
          >
            开启调试模式
          </a-checkbox>
          <a-checkbox
            :defaultChecked="clientSetupData.disabledScreenAudio ? true : false"
            @change="handleUpdateSetting({ disabledScreenAudio: $event.target.checked ? 1 : 0 })"
          >
            禁用“共享屏幕声音”
          </a-checkbox>
          <a-checkbox
            :defaultChecked="clientSetupData.keepActive ? true : false"
            @change="handleUpdateSetting({ keepActive: $event.target.checked ? 1 : 0 })"
          >
            是否“保活”
          </a-checkbox>
          <!-- <a-checkbox
		  	  	:defaultChecked="clientSetupData.autoLogin"
		  	  	@change="handleUpdateSetting({ autoLogin: clientSetupData.autoLogin })"
		  	  	>开启RTMP直播</a-checkbox
		  	  > -->
        </div>
      </div>
    </template>
    <div class="empty-box" v-else>
      <a-empty :image="simpleImage" description="暂无客户端绑定该教室" />
    </div>
  </div>
</template>

<script>
import { Empty } from 'ant-design-vue'
export default {
  props: {
    classroomCode: {
      type: String
    }
  },
  data() {
    return {
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      clientSetupData: {},
      windowList: [
        { value: 1, label: '小窗' },
        { value: 2, label: '中窗' },
        { value: 3, label: '全屏' },
        { value: 4, label: '收起' }
      ],
      posList: [
        { value: 1, label: '左上' },
        { value: 2, label: '右上' },
        { value: 3, label: '左下' },
        { value: 4, label: '右下' },
        { value: 5, label: '隐藏' }
      ],
      clientForZRTC: null,
      showRestartBtn: true
    }
  },
  beforeDestroy() {
    this.clientForZRTC && this.clientForZRTC.leaveRoom()
  },
  methods: {
    async getClientSetup() {
      const res = await this.$http.getClassroomClientSet({
        classroomCode: this.classroomCode
      })
      console.log('clientSetting🔧:>>>>>>>', res, 'clientSetup.vue')
      if (res.code === 200) {
        this.clientSetupData = res.rt || {}
        if (res.rt.liveId) {
          this.showRestartBtn = true
          if (!this.clientForZRTC) {
            this.clientForZRTC = await this.ZRTCInit()
          }
        } else {
          this.showRestartBtn = false
        }
      }
    },
    ZRTCInit() {
      return new Promise(async (resolve) => {
        let liveId = this.clientSetupData.liveId
        const client = ZRTC2.init(liveId)
        client.setClientRole('audience')
        client.setBaseUrl({
          // hilive: 'https://tju-hilive.zhihuishu.com',
          hilive: 'https://zhs-hilive.zhihuishu.com',
          // 'zhihuishu-livecourse-desktop': 'https://tju-zhihuishu-livecourse-desktop.zhihuishu.com'
          'zhihuishu-livecourse-desktop': 'https://zhs-zhihuishu-livecourse-desktop.zhihuishu.com'
        })
        try {
          await client.joinAudienceRoom()
          console.log('joinRoom success')
          resolve(client)
        } catch (err) {
          console.log(err, 'joinRoom_err')
          return this.$message.error('抱歉，当前加入直播人数已达上限，无法加入！')
        }
      })
    },
    sendCustomSignal(txType, content) {
      const { socketId } = this.clientSetupData
      if (this.clientForZRTC.sendCustomSignal) {
        this.clientForZRTC.sendCustomSignal({
          txType,
          to: socketId,
          content: {
            ...content
          }
        })
      }
    },
    async handleUpdateSetting(item) {
      console.log('params🔧:>>>>>>>', item, 'clientSetup.vue')
      try {
        const params = JSON.parse(JSON.stringify(this.clientSetupData))
        Object.assign(params, {
          ...item
        })
        const res = await this.$http.editClientSetup({
          macAddr: this.clientSetupData.macAddr,
          ...params
        })
        console.log('updateRes🔧:>>>>>>>', res, 'clientSetup.vue')
        if (res.code === 200 && res.rt.resultStatus == 1) {
          this.$message.success('操作成功，下次启用客户端时生效')
          this.getClientSetup()
        }
      } catch (err) {
        console.log(err)
      }
    },
    handleWindowType(value) {
      console.log('value🔧:>>>>>>>', value, 'clientSetup.vue')
      this.handleUpdateSetting({ windowType: value })
    },
    async handleWindowPos(value) {
      console.log('value🔧:>>>>>>>', value, 'clientSetup.vue')
      await this.handleUpdateSetting({ miniWindowPositionType: value })
      if (this.clientSetupData.socketId) {
        this.sendCustomSignal('mini-window-position-type', { miniWindowPositionType: value })
      }
    },
    confirmOrCancelUnbindClient(macAddr) {
      const _that = this
      this.$confirm({
        title: '请问确定要解绑吗?',
        content: '',
        zIndex: 1000,
        onOk() {
          _that.unbindClient(macAddr)
        },
        onCancel() {}
      })
    },
    async unbindClient(macAddr) {
      if (!macAddr) return
      const res = await this.$http.unbindClassroomByAddr({
        macAddr: macAddr
      })
      console.log('unbind🔧:>>>>>>>', res, 'clientSetup.vue')
      if (res.code === 200) {
        if (res.rt == null) {
          this.$message.success('操作成功')
        }
        if (res.rt.resultStatus == -1) {
          this.$message.error(res.rt.resultMessage)
        }
      }
    },
    handleRestart() {
      const _that = this
      this.$confirm({
        title: '请问确定要重启客户端吗?',
        content: '',
        zIndex: 1000,
        onOk() {
          _that.sendCustomSignal('restart-client', {})
        },
        onCancel() {}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.client-setup-container {
  text-align-last: left;
}
.setup-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  .client-uuid {
    width: 80px;
  }
  .uuid-code {
    width: 300px;
    margin-right: 10px;
  }
}
.option-item {
  display: flex;
  .option-title {
    width: 80px;
  }
  .choose-box {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  }
  .select-option {
    margin-bottom: 10px;
  }
  .select-title {
    margin-right: 10px;
  }
}
.advance-set {
  margin-top: 10px;
}
::v-deep .ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 0;
}
::v-deep .ant-checkbox-wrapper {
  margin-bottom: 10px;
}
.empty-box {
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  ::v-deep .ant-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
